var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.$route.data))]),_c('ui-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.$router.push('/index')}}},[_vm._v(_vm._s(_vm.$t("backToHome")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }